'use strict';

/** @type {import('./min')} */
module.exports = Math.min;



//////////////////
// WEBPACK FOOTER
// ./node_modules/math-intrinsics/min.js
// module id = 616
// module chunks = 0